import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MessageLogsVoiceReportGeneratorStore } from './message-logs-voice-report-generator.store';
import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { UniAuthFacade } from 'unifonic-spa-common/src/modules/uni-auth/shared/uni-auth.facade';

@Component({
  selector: 'app-message-logs-voice-report-generator',
  templateUrl: './message-logs-voice-report-generator.component.html',
  styleUrls: ['./message-logs-voice-report-generator.component.scss'],
  providers: [MessageLogsVoiceReportGeneratorStore]
})
export class MessageLogsVoiceReportGeneratorComponent implements OnInit {

  vm$ = this.store.vm$

  positions: ConnectedPosition[] =[{
    originX: 'center',
    originY: 'center',
    overlayX: 'center',
    overlayY: 'center',
  }]

  constructor(
    private store: MessageLogsVoiceReportGeneratorStore,
    protected uniAuthFacade: UniAuthFacade,
  ) { }

  ngOnInit(): void {
  }

  downloadReport(){
    this.store.generateReport()
  }

  closePopup(){
    this.store.patchState({infoPopupVisibility: false})
  }

  get isImpresonationSession(): boolean {
    return this.uniAuthFacade.isImpresonationSession();
  }
}
